import type React from "react";

import { styled } from "simplydo/react/styled";

// Adding `1` to the top parameters fixes some weird offset scrolling issues, without this there is one pixel of wiggle-room where the sticky bar actually scrolls out of view for a pixel. Adding the extra one pixel fixes this issue
const StyledDiv = styled.div`
  position: -webkit-sticky;
  position: sticky;
`;

type StickyProps = {
  top?: number;
  bottom?: number;
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
};

const Sticky = ({
  top,
  bottom,
  style,
  className,
  children,
  ref,
}: StickyProps) => {
  const positionStyle: React.CSSProperties =
    bottom !== undefined ? { bottom } : { top: top ?? 0 };

  return (
    <StyledDiv
      ref={ref}
      style={{ ...positionStyle, ...style }}
      className={className}
    >
      {children}
    </StyledDiv>
  );
};

export default Sticky;
